import React from "react";
import { useNavigate } from "react-router-dom";
import styles from "./ContactCTA.module.css";

const ContactCTA = () => {
  const navigate = useNavigate();
  
  return (
    <section className={styles.contactCTA}>
      <div className={styles.container}>
        <div className={styles.ctaContent}>
          <h2 className={styles.ctaTitle}>Elevate Your Property with Timeless Elegance</h2>
          <p className={styles.ctaText}>
            Our master stone craftsmen await to transform your vision into enduring magnificence.
            Request a personalized consultation with our distinguished experts today.
          </p>
          <div className={styles.contactOptions}>
            <a href="mailto:chamarathronestone@yahoo.com" className={styles.contactOption}>
              <div className={styles.optionIcon}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
                </svg>
              </div>
              <div className={styles.optionContent}>
                <h4>Email</h4>
                <span>chamarathronestone@yahoo.com</span>
              </div>
            </a>
            <a href="tel:+94711155357" className={styles.contactOption}>
              <div className={styles.optionIcon}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/>
                </svg>
              </div>
              <div className={styles.optionContent}>
                <h4>Telephone</h4>
                <span>+94 767790567</span>
                <br></br>     
                <span>+94 767934836</span>
                <br></br>    
                <span>Whatsapp - +94 714785357</span>
              </div>
            </a>
          </div>
          <button 
            className={styles.ctaButton}
            onClick={() => navigate("/contact")}
          >
              Contact Us
          </button>
        </div>
      </div>
    </section>
  );
};

export default ContactCTA;